import { drama } from '../../../../constants/actionTypes';

export default (state = [], { type, commentId }) => {
  switch (type) {
    case drama.FETCH_DRAMA_REPLIES:
      return [...state, commentId];

    case drama.FETCH_DRAMA_REPLIES_SUCCESS:
    case drama.FETCH_DRAMA_REPLIES_FAILED:
      return state.filter(id => id !== commentId);

    default:
      return state;
  }
};
